<app-loader></app-loader>

<div class="d-flex flex-column">
  @if (acesso) {
    <div class="container_nav_bar">
      <app-nav-bar></app-nav-bar>
    </div>
  }

  <div>
    <div [ngClass]="cssContainerConteudo">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

@if (telefoniaChamadaRecebida != null) {
  <div class="softphone_chamada_popup">
    <div class="softphone_chamada_topo">
      <div>
        <div class="softphone_chamada_titulo">Chamada recebida</div>
        @if (telefoniaChamadaRecebida.codigo_no_erp_do_cliente != '') {
          <div class="softphone_chamada_subtitulo">{{ telefoniaChamadaRecebida.identificacao }}</div>
        }
        @if (telefoniaChamadaRecebida.codigo_no_erp_do_cliente == '') {
          <div class="softphone_chamada_subtitulo">Cliente nao identificado</div>
        }
      </div>
      <button type="button" class="softphone_chamada_fechar" (click)="telefoniaFecharPopup()">x</button>
    </div>

    <div class="softphone_chamada_numero">{{ telefoniaChamadaRecebida.numero_telefone }}</div>

    @if (telefoniaChamadaRecebida.codigo_no_erp_do_cliente != '') {
      <div class="softphone_chamada_dados">
        <div><strong>Razao Social:</strong> {{ telefoniaChamadaRecebida.identificacao }}</div>
        <div><strong>Cod ERP:</strong> {{ telefoniaChamadaRecebida.codigo_no_erp_do_cliente }}</div>
        <div><strong>Vendedor Externo:</strong> {{ telefoniaChamadaRecebida.vendedor_externo || '-' }}</div>
        <div><strong>Vendedor Interno:</strong> {{ telefoniaChamadaRecebida.vendedor_interno || '-' }}</div>
      </div>
    }

    <div class="softphone_chamada_acoes">
      <button type="button" class="btn btn-success" (click)="telefoniaAtender()">Atender</button>
    </div>
  </div>
}

@if (telefoniaAbrirLigacaoPendente != null) {
  <div class="softphone_modal_overlay">
    <div class="softphone_modal">
      <div class="softphone_modal_icone">☎</div>
      <div class="softphone_modal_titulo">Abrir ligação do cliente?</div>
      <div class="softphone_modal_texto">
        A chamada foi atendida. Deseja abrir a tela de ligação de
        <strong>{{ telefoniaAbrirLigacaoPendente.identificacao }}</strong> agora?
      </div>
      <div class="softphone_modal_dados">
        <div><strong>Cod ERP:</strong> {{ telefoniaAbrirLigacaoPendente.codigo_no_erp_do_cliente }}</div>
        <div><strong>Telefone:</strong> {{ telefoniaAbrirLigacaoPendente.numero_telefone }}</div>
      </div>
      <div class="softphone_modal_acoes">
        <button type="button" class="btn btn-outline-secondary" (click)="telefoniaCancelarAbrirLigacao()">Agora nao</button>
        <button type="button" class="btn btn-success" (click)="telefoniaConfirmarAbrirLigacao()">Abrir ligação</button>
      </div>
    </div>
  </div>
}
